import { DenialType } from "generated-graphql/graphql";

type MinimalDeniedFacility = {
  denialReasons: {
    type?: DenialType | null;
    configRule?: { value: string } | null;
  }[];
};

export function parseDenialReasonsToText(row: MinimalDeniedFacility): string[] {
  return (
    row?.denialReasons?.map((reason) => {
      switch (reason.type) {
        case DenialType.ExplicitFacility:
          return `🚫 Denied at facility level`;
        case DenialType.ExplicitTenant:
          return `🏢 Denied at tenant level`;
        case DenialType.ExplicitTenantForState: {
          // Key format: "tenantId:stateAbbreviation" - see buildTenantStateKey in encamp-workflows/src/utils.ts
          const state = reason.configRule?.value?.split(":")[1] ?? "unknown";
          return `🏢 Denied at tenant level for ${state}`;
        }
        case DenialType.ImplicitState:
          return `📍 State not allowed (${reason.configRule?.value} not in allowed states)`;
        case DenialType.ImplicitEnvironment:
          return `🌍 Environment not allowed (${reason.configRule?.value} not in allowed environments)`;
        default:
          return "Unknown";
      }
    }) ?? []
  );
}
